import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import {
  DashboardWidgetPlacement,
  DashboardWidgetSizeLimits,
  clampWidgetPlacement,
} from '../../widget-and-graphs.models';

@Component({
  selector: 'app-dashboard-grid-item',
  standalone: false,
  templateUrl: './dashboard-grid-item.html',
  styleUrl: './dashboard-grid-item.scss',
})
export class DashboardGridItem {
  @Input({ required: true }) placement!: DashboardWidgetPlacement;
  @Input({ required: true }) limits!: DashboardWidgetSizeLimits;
  @Input() editMode = false;
  @Input() unit = 80;
  @Input() gap = 16;

  @Output() placementChange = new EventEmitter<DashboardWidgetPlacement>();
  @Output() remove = new EventEmitter<void>();

  @HostBinding('style.grid-column')
  get gridColumn(): string {
    const placement = this.boundedPlacement;
    return `${placement.x + 1} / span ${placement.width}`;
  }

  @HostBinding('style.grid-row')
  get gridRow(): string {
    const placement = this.boundedPlacement;
    return `${placement.y + 1} / span ${placement.height}`;
  }

  @HostBinding('style.max-height.px')
  get maximumHeight(): number {
    return this.limits.maxHeight * this.unit + Math.max(0, this.limits.maxHeight - 1) * this.gap;
  }

  private get boundedPlacement(): DashboardWidgetPlacement {
    return clampWidgetPlacement(this.placement, this.limits);
  }

  onDragEnded(event: CdkDragEnd): void {
    const cell = Math.max(1, this.unit + this.gap);
    const delta = event.source.getFreeDragPosition();
    event.source.reset();
    this.placementChange.emit({
      ...this.placement,
      x: this.placement.x + Math.round(delta.x / cell),
      y: this.placement.y + Math.round(delta.y / cell),
    });
  }

  resize(widthDelta: number, heightDelta: number): void {
    this.placementChange.emit(clampWidgetPlacement({
      ...this.placement,
      width: this.placement.width + widthDelta,
      height: this.placement.height + heightDelta,
    }, this.limits));
  }

}
